export const QUOTE_ON_NET_3RD_PARTY_MESSAGE =
  "You've chosen an on-net or 3rd party building, we will proceed with an Ethernet Fibre and/or Optical Wavelength quote depending on availability.";
